import style from "./RecoveryPassword.module.css";
import animation from "../../assets/lottie/denied service.json";
import animationSuccess from "../../assets/lottie/success.json";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios, { AxiosError, AxiosResponse } from "axios";
import { endpoint, passwordSchema } from "../../services/shared";
import Snackbar from "@mui/material/Snackbar";
import {
  Alert,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import HeaderAffida from "../../components/header/HeaderAffida";
import Lottie from "lottie-react";
import z from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormLabel } from "../../components/form-label/FormLabel";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {apiClient} from "../../services/api";

type PasswordFormType = {
  password: string;
  confirmPassword: string;
};

const formSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(8, "Almeno 8 caratteri"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"], // Dove mostrare l'errore
    message: "Le password non coincidono",
  });

export default function RecoveryPassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState<"new" | "confirm">();
  const [success, setSuccess] = useState<boolean>(false);

  const [available, setAvailability] = useState<boolean>(true);
  const [token, setToken] = useState<string>();
  const [uid, setUid] = useState<string>();
  const location = useLocation();
  const [snackState, setSnackState] = useState<boolean>(false);
  const [snackMessage, setSnackMessage] = useState<{
    severity: any;
    message: string;
  }>({
    severity: "success",
    message: "",
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<PasswordFormType>({
    resolver: zodResolver(formSchema),
  });

  const onSubmit = handleSubmit(async (data: PasswordFormType) => {
    setSnackState(false);
    let res: AxiosResponse | null = null;
    const payload = {
      uid,
      newPassword: data.password.trim(),
      token,
    };
    try {
      res = await apiClient.post(`/v1/auth/set-new-password`, payload);
    } catch (e: AxiosError | any) {
      console.error("errore", e);
      setSnackMessage({
        severity: "error",
        message: e.response?.data.error,
      });
      setSnackState(true);
    }
    if (res?.data.ok === true) {
      setSnackMessage({ severity: "success", message: res?.data.message });
      setSnackState(true);
      setSuccess(true);
    }
    return;
  });

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const token = pathParts[pathParts.length - 2];
    const uid = pathParts[pathParts.length - 1];
    setToken(token);
    setUid(uid);
    console.log("token", token);
    console.log("uid:", uid);
  }, [location]);
  const verifyToken = async () => {
    let res: AxiosResponse | null = null;
    try {
      res = await apiClient.post(`/v1/auth/verifica-tk`, {
        uid,
        token,
      });
    } catch (e: AxiosError | any) {
      console.error("errore", e);
      setAvailability(false);
      setSnackMessage({
        severity: "error",
        message: e?.response.data.error,
      });
      setSnackState(true);
    }
    if (res?.status && res?.status === 200) {
      setAvailability(true);
      // reset();
    }
  };
  useEffect(() => {
    if (uid && token) {
      verifyToken();
    }
  }, [uid, token]); // dipende da uid e token

  return (
    <div className={"container"}>
      <HeaderAffida />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackState}
        onClose={() => setSnackState(false)}
        autoHideDuration={3000}
      >
        <Alert
          onClose={() => setSnackState(false)}
          severity={snackMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackMessage.message}
        </Alert>
      </Snackbar>
      {available ? (
        !success ? (
          <div className={"flex-col"} style={{ alignItems: "center" }}>
            <form
              onSubmit={onSubmit}
              style={{ maxWidth: "320px", marginTop: 0 }}
            >
              <FormLabel label={"Reimposta password"} />
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <FormControl
                    style={{ marginBottom: "1.5em" }}
                    fullWidth
                    size="small"
                    error={!!errors.password}
                  >
                    <InputLabel htmlFor="password">Nuova password</InputLabel>
                    <OutlinedInput
                      id="password"
                      {...field}
                      type={showPassword === "new" ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowPassword((s) =>
                                s !== "new" ? "new" : undefined,
                              )
                            }
                            edge="end"
                          >
                            {showPassword === "new" ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                    <FormHelperText>{errors.password?.message}</FormHelperText>
                  </FormControl>
                )}
              />
              <Controller
                name="confirmPassword"
                control={control}
                render={({ field }) => (
                  <FormControl
                    style={{ marginBottom: "1.5em" }}
                    fullWidth
                    size="small"
                    error={!!errors.confirmPassword}
                  >
                    <InputLabel htmlFor="confirmPassword">
                      Conferma password
                    </InputLabel>
                    <OutlinedInput
                      id="password"
                      {...field}
                      type={showPassword === "confirm" ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowPassword((s) =>
                                s !== "confirm" ? "confirm" : undefined,
                              )
                            }
                            edge="end"
                          >
                            {showPassword === "confirm" ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                    <FormHelperText>
                      {errors.confirmPassword?.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                {isSubmitting ? "Elaboro richiesta" : "Salva"}
              </Button>
            </form>
          </div>
        ) : (
          <div
            className={"flex-row gap-2"}
            style={{
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <div style={{ width: 165, height: 165 }}>
              <Lottie animationData={animationSuccess} loop={true} />
            </div>
            <div className={"flex-col gap-1"} style={{ maxWidth: "460px" }}>
              <h2
                style={{
                  marginBottom: "0",
                  marginTop: 0,
                  padding: 0,
                  fontSize: "26px",
                }}
              >
                Complimenti hai reimpostato la tua password!
              </h2>
              <p
                style={{
                  margin: 0,
                  padding: 0,
                  fontSize: "16px",
                  color: "#656565",
                  fontWeight: 300,
                }}
              >
                Ora puoi utilizzare la nuova password per eseguire l'accesso,
                torna alla login e rimettiti al lavoro.
              </p>
              <Button
                style={{ maxWidth: "fit-content" }}
                variant={"contained"}
                onClick={() => navigate("/login")}
              >
                Torna al login
              </Button>
            </div>
          </div>
        )
      ) : (
        <div
          className={"flex-row gap-2"}
          style={{
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ width: 165, height: 165 }}>
            <Lottie animationData={animation} loop={true} />
          </div>
          <div className={"flex-col gap-1"} style={{ maxWidth: "460px" }}>
            <h2
              style={{
                marginBottom: "0",
                marginTop: 0,
                padding: 0,
                fontSize: "26px",
              }}
            >
              Ci dispiace il token è scaduto o non valido
            </h2>
            <p
              style={{
                margin: 0,
                padding: 0,
                fontSize: "16px",
                color: "#656565",
                fontWeight: 300,
              }}
            >
              È probabile che tu abbia già cambiato la password, prova di nuovo
              ad avviare la procedura di reset se vuoi cambiarla di nuovo.
            </p>
            <Button
              style={{ maxWidth: "fit-content" }}
              variant={"contained"}
              onClick={() => navigate("/login")}
            >
              Torna al login
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
